export const myTeamFilterOptions = [
    { id: "role", value: "roles", label: "Role Packet" },
    { id: "skill", value: "skills", label: "Skill" }
];
